import { render, staticRenderFns } from "./AttrTable.vue?vue&type=template&id=4c7d7729&"
import script from "./AttrTable.vue?vue&type=script&lang=js&"
export * from "./AttrTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports